import type { Cue } from '@rundown-studio/types'

export type SettingsState = Cue['settings']

export const settingsConfig = [
  { key: 'skipDuringShow' as keyof SettingsState, label: 'Skip during show' },
  { key: 'hideOnPdf' as keyof SettingsState, label: 'Hide on PDF export' },
  { key: 'hideOnCsv' as keyof SettingsState, label: 'Hide on CSV export' },
  { key: 'preventEdits' as keyof SettingsState, label: 'Prevent edits' },
] as const
